import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "When mainstream platforms don't fit, we build a custom CMS shaped entirely around your content and your editors. You get exactly the fields, roles and workflows you need — and nothing you don't.",
    "The result is a lean, secure system that's faster to use, easier to maintain and free of the plugin sprawl that slows generic platforms down.",
];

const FEATURES = [
    { title: "Built around your content", text: "Content types, fields and relationships modelled to fit your material precisely." },
    { title: "Role-based workflows", text: "Editing, review and publishing flows that match how your team actually works." },
    { title: "Lean & secure", text: "Only the code you need, which means a smaller attack surface and better performance." },
    { title: "Full ownership", text: "You own the platform outright — no licensing traps or vendor lock-in." },
];

const CHECKS = [
    "Bespoke content modelling",
    "Custom editorial workflows",
    "API-first architecture",
    "Third-party integrations",
    "Ongoing support",
];

export default function CustomCms() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="CMS & Migration" title="Custom CMS Development" eyebrowAs="span">
                    A content system built around your content — no unused features, no compromises, just the workflow your team needs.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
